import { buildRouteHead } from "@/lib/seo/routeHead";
import { createFileRoute, redirect } from "@tanstack/react-router";

// Legacy URL for the renamed Annex 1 webinar — redirects to the new slug.
export const Route = createFileRoute("/en/webinars/annex-1-in-practice-ccs-governance-first-air-risk-filter-strategy")({
  head: () => buildRouteHead("/en/webinars/annex-1-in-practice-ccs-governance-first-air-risk-filter-strategy", { noIndex: true }),
  beforeLoad: () => {
    throw redirect({ href: "/en/webinars/annex-1-in-practice-field-tested-answers-implementation-challenges", replace: true });
  },
});
